import { Column, Row } from '@vp/swan'
import React from 'react'
import Tile from './Tile'
import type { Tile as TileData } from '../../types/homepageFeatureTileRow'
import type { TileSkin } from '../../types/sharedTypes'

// Displays tiles as a 2x2 grid on sm and xs screens for first feature tile row or when authoring option is selected
const isInLastRow = (index: number, length: number) => {
  const tileNumber = index + 1
  return tileNumber >= length - 1
}

interface GridTilesListProps {
  tiles: Array<TileData>
  tileSkin?: TileSkin
  enableCampaignCallouts: boolean
  showPrice: boolean
  loadType: string
  trackingPageZone: string
  locale: string
  /** Accepted for parity with sibling tile-list components; unused here. */
  id?: string
}

const GridTilesList = (props: GridTilesListProps) => {
  const { tiles, tileSkin, enableCampaignCallouts, showPrice, loadType, trackingPageZone, locale } = props
  const evenTiles = tiles.length % 2 === 0 ? tiles : tiles.slice(0, tiles.length - 1)
  return (
    <Row as="ul">
      {evenTiles.map((tile, index) => {
        return (
          <Column as="li" key={index} span={6} spanXs={6} spanSm={6}>
            <Tile
              loadType={loadType}
              data={tile}
              position={index + 1}
              trackingPageZone={trackingPageZone}
              enableCampaignCallouts={enableCampaignCallouts}
              showPrice={showPrice}
              tileSkin={tileSkin}
              locale={locale}
              marginBottom={isInLastRow(index, evenTiles.length) ? 0 : undefined}
            />
          </Column>
        )
      })}
    </Row>
  )
}

export default GridTilesList
